import axios from './http';

import { CancelTokenSource } from 'axios';
import { MandateConfigDto, MandateDto, UpsertMandateConfigDto } from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/mandates`;

export const searchMandates = (query: String,
                               source: CancelTokenSource): Promise<Array<MandateDto>> => {
  return axios
      .get(`${apiUri}`, {params: {query: query}, cancelToken: source.token})
      .then(response => response.data);
};

export const getAllMandates = (source: CancelTokenSource): Promise<Array<MandateConfigDto>> => {
  return axios
      .get(apiUri, {cancelToken: source.token})
      .then((response) => response.data);
};

export const findMandateById = (id: number, source: CancelTokenSource): Promise<MandateConfigDto> => {
  return axios
      .get(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data);
};

export const deleteMandate = (id: number, source: CancelTokenSource): Promise<MandateConfigDto> => {
  return axios
      .delete(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data)
};

export const addMandate = (upsertMandatesettingsDto: Partial<UpsertMandateConfigDto>, source: CancelTokenSource): Promise<MandateConfigDto> => {
  return axios
      .post(apiUri, upsertMandatesettingsDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const editMandate = (id: number, upsertMandatesettingsDto: Partial<UpsertMandateConfigDto>,
                            source: CancelTokenSource): Promise<MandateConfigDto> => {
  return axios
      .put(`${apiUri}/${id}`, upsertMandatesettingsDto, {cancelToken: source.token})
      .then(response => response.data);
};
